import {
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Tooltip,
  Typography,
} from "antd";
import dayjs from "dayjs";
import "dayjs/locale/vi";
import { FIELD_TYPE } from "../../../type/fileType";

dayjs.locale("vi");
const { INPUT, SELECT, NUMBER, COMBO_BOX, DATE, CURRENCY } = FIELD_TYPE;

const FormItem = (props) => {
  const {
    placeholder,
    suffix,
    disable,
    checkbox,
    type,
    options,
    addonAfter,
    radioButtons,
    className,
    labelCol,
    wrapperCol,
    rules,
    name,
    label,
    value,
    radioButton,
    onChange,
    onSearch,
    onPressEnter,
    statusDrug,
    defaultValue,
    onSelect,
    radioCustom,
    disabledDate,
    minCurrency,
    valuePropName,
    mode,
    filterOption,
    initialValue = null,
    allowClear = true,
    changeOnBlur,
    optionsTime = { showTime: false, format: "DD/MM/YYYY" },
    disableDate = true,

    ...rest
  } = props;
  const renderFormItem = () => {
    switch (type) {
      case INPUT:
        return (
          <Input
            style={{
              width: "100%",
            }}
            value={value ?? null}
            placeholder={!disable ? placeholder ?? "Nhập" : "--"}
            suffix={suffix}
            disabled={disable}
            addonAfter={addonAfter}
            allowClear
            onChange={onChange}
            {...rest}
          />
        );
      case COMBO_BOX:
        return (
          <Select
            mode={mode}
            showSearch
            style={{
              width: "100%",
            }}
            filterOption={(input, option) =>
              (option?.label?.toString().toLowerCase() ?? "").includes(
                input.toLowerCase()
              )
            }
            defaultValue={value ?? null}
            placeholder={!disable ? placeholder ?? "Chọn" : "--"}
            options={options}
            disabled={disable}
            allowClear={allowClear}
            onChange={onChange}
            {...rest}
            size="large"
          />
        );
      case SELECT:
        return (
          <Select
            style={{
              width: "100%",
            }}
            placeholder={!disable ? placeholder ?? "Chọn" : "--"}
            options={options}
            disabled={disable}
            onChange={onChange}
            allowClear={allowClear}
            size="large"
            {...rest}
          />
        );
      case NUMBER:
        return (
          <InputNumber
            style={{ width: "100%" }}
            placeholder={!disable ? placeholder ?? "Nhập" : "--"}
            disabled={disable}
            value={value}
            addonAfter={addonAfter}
            defaultValue={value}
            controls={false}
            onChange={onChange}
            {...rest}
          ></InputNumber>
        );

      case DATE:
        return (
          <DatePicker
            style={{
              width: "100%",
            }}
            disabled={disable}
            format={optionsTime.format}
            showTime={optionsTime.format == "DD/MM/YY"}
            {...rest}
            // disabledDate={
            //   disableDate
            //     ? (current) => {
            //         return current.isAfter(dayjs());
            //       }
            //     : false
            // }
            placeholder={!disable ? optionsTime.format ?? "Chọn" : "--"}
            onChange={onChange}
            allowClear
            changeOnBlur={changeOnBlur}
          />
        );
      case CURRENCY:
        return (
          <InputNumber
            style={{ width: "100%" }}
            defaultValue={value}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => (value || "").replace(/\$\s?|(,*)/g, "")}
            onChange={onChange}
            stringMode
            controls={false}
            disabled={disable}
            min={minCurrency ? minCurrency : 0}
            {...rest}
            suffix={"VND"}
          />
        );
      default:
        break;
    }
  };
  return (
    <Form.Item
      className={className}
      rules={rules}
      labelCol={{
        xs: labelCol.xs,
        sm: labelCol.sm,
        md: labelCol.md,
        lg: labelCol.lg,
        xl: labelCol.xl,
      }}
      wrapperCol={{
        xs: wrapperCol.xs,
        sm: wrapperCol.sm,
        md: wrapperCol.md,
        lg: wrapperCol.lg,
        xl: wrapperCol.xl,
      }}
      initialValue={initialValue}
      label={
        label ? (
          <Tooltip placement="bottom" arrow={false} title={label}>
            <Typography.Text
              className="form-item-text"
              style={{
                // whiteSpace: "pre-wrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                marginRight: "5px",
              }}
            >
              {label}
            </Typography.Text>
          </Tooltip>
        ) : (
          ""
        )
      }
      valuePropName={valuePropName}
      name={name}
    >
      {renderFormItem()}
    </Form.Item>
  );
};

export default FormItem;
